import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import {deleteTeam, getInternationalTeam} from "../../actions/International";
import {IMAGE_URL} from "../../path";
import {deleteNewsPost} from "../../actions/NewsPages";

function InternationalTeam() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const user = location.state?.user;
    const navigate = useNavigate();
    const [internationalTeam, setInternationalTeam] = useState<any[]>([]);

    function fetchInternationalTeam() {
        getInternationalTeam()
            .then(response => {
                setInternationalTeam(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch international team:", error);
            })
    }

    useEffect(() => {
        fetchInternationalTeam();
    }, []);

    async function handleDelete(teamMemberId: number) {
        if (window.confirm("Are you sure you want to delete this team member?")) {
            try {
                await deleteTeam(teamMemberId);
                fetchInternationalTeam();
            } catch (error) {
                console.error("Failed to delete team member:", error);
                alert("Failed to delete the team member. Please try again.");
            }
        }
    }



    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="main-admin-page-inner">
                <div className="content-form-button right-align" style={{marginBottom: '20px'}}>
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/international/team/add', { state: { user } })}
                    >
                        Add New Team Member
                    </button>
                </div>
                <table className="news-table">
                    <thead>
                        <tr>
                            <td style={{width: '20%'}}>Name</td>
                            <td style={{width: '15%'}}>Position</td>
                            <td style={{width: '20%'}}>Email</td>
                            <td style={{width: '15%'}} >Image</td>
                            <td style={{width: '10%'}}>Order</td>
                            <td style={{width: '20%'}}>Actions</td>
                        </tr>
                    </thead>
                    <tbody>
                    {internationalTeam.map((teamMember) => (
                        <tr key={teamMember.id}>
                            <td>{teamMember.name}</td>
                            <td>{teamMember.title}</td>
                            <td>{teamMember.email_address}</td>
                            <td>
                                <div style={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                                    <img
                                        src={`${IMAGE_URL}${teamMember.image_path}`}
                                        alt={teamMember.name}
                                        style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                </div>

                            </td>
                            <td>{teamMember.display_order}</td>
                            <td>
                                <button
                                    className="button small"
                                    onClick={() => navigate(`/dashboard/international/team/${teamMember.id}/edit`, {state: {user: user}})}
                                    style={{ marginRight: "10px", marginBottom: '10px' }}
                                >
                                    View / Edit
                                </button>
                                <button
                                className="button small danger"
                                onClick={() => handleDelete(teamMember.id)}
                                style={{ color: "black" }}
                            >
                                Delete
                            </button></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>

    </div>;
}

export default InternationalTeam;
